"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipValueColor = exports.getTooltipXVal = exports.showTooltipComponents = exports.hideTooltipComponents = exports.getMouseXYVal = exports.moveTooltipXAxisMarker = exports.moveTooltip = exports.getAbsoluteTooltipLocation = exports.getRelativeTooltipLocation = exports.moveTooltipLine = exports.X_AXIS_MARKER_PADDING = exports.PIXELS_PER_X_AXIS_LABEL_CHAR = exports.TOOLTIP_MARGIN_Y = exports.TOOLTIP_MARGIN_X = exports.CHART_TOOLTIP_WIDTH = exports.NEGATIVE_COLOR = exports.POSITIVE_COLOR = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
var pipe_1 = tslib_1.__importDefault(require("lodash/fp/pipe"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/fp/flatMap"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
var sortedUniq_1 = tslib_1.__importDefault(require("lodash/fp/sortedUniq"));
var sortBy_1 = tslib_1.__importDefault(require("lodash/fp/sortBy"));
var utils_1 = require("../../utils");
exports.POSITIVE_COLOR = utils_1.theme.colors.green[400];
exports.NEGATIVE_COLOR = utils_1.theme.colors.red[400];
exports.CHART_TOOLTIP_WIDTH = 232;
exports.TOOLTIP_MARGIN_X = 8;
exports.TOOLTIP_MARGIN_Y = 12;
exports.PIXELS_PER_X_AXIS_LABEL_CHAR = 8;
exports.X_AXIS_MARKER_PADDING = 8;
exports.moveTooltipLine = function (_a) {
    var tooltipLine = _a.tooltipLine, xLocation = _a.xLocation;
    if (xLocation !== undefined) {
        d3.select(tooltipLine)
            .attr('opacity', 1)
            .attr('transform', "translate(" + xLocation + ", 0)");
    }
    else {
        d3.select(tooltipLine).transition().attr('opacity', 0);
    }
};
exports.getRelativeTooltipLocation = function (_a) {
    var relativeTargetLocationX = _a.relativeTargetLocationX, relativeTargetLocationY = _a.relativeTargetLocationY, tooltipWidth = _a.tooltipWidth, tooltipHeight = _a.tooltipHeight, windowWidth = _a.windowWidth, windowHeight = _a.windowHeight, _b = _a.flipWidth, flipWidth = _b === void 0 ? 0 : _b;
    var tooltipXLocation = relativeTargetLocationX + exports.TOOLTIP_MARGIN_X;
    var tooltipYLocation = relativeTargetLocationY + exports.TOOLTIP_MARGIN_Y;
    if (relativeTargetLocationX + tooltipWidth + exports.TOOLTIP_MARGIN_X >=
        windowWidth) {
        tooltipXLocation =
            relativeTargetLocationX - flipWidth - exports.TOOLTIP_MARGIN_X - tooltipWidth;
    }
    if (relativeTargetLocationY + tooltipHeight + exports.TOOLTIP_MARGIN_Y >=
        windowHeight) {
        tooltipYLocation =
            relativeTargetLocationY - exports.TOOLTIP_MARGIN_Y - tooltipHeight;
        tooltipYLocation = tooltipYLocation < -50 ? -50 : tooltipYLocation;
    }
    return {
        tooltipXLocation: tooltipXLocation,
        tooltipYLocation: tooltipYLocation,
    };
};
exports.getAbsoluteTooltipLocation = function (_a) {
    var absoluteTargetLocationX = _a.absoluteTargetLocationX, absoluteTargetLocationY = _a.absoluteTargetLocationY, tooltipXOffset = _a.tooltipXOffset, tooltipYOffset = _a.tooltipYOffset, relativeTargetLocationX = _a.relativeTargetLocationX, relativeTargetLocationY = _a.relativeTargetLocationY, windowWidth = _a.windowWidth, windowHeight = _a.windowHeight, tooltipHeight = _a.tooltipHeight, tooltipWidth = _a.tooltipWidth, _b = _a.flipWidth, flipWidth = _b === void 0 ? 0 : _b;
    var tooltipXLocation = absoluteTargetLocationX + tooltipXOffset + exports.TOOLTIP_MARGIN_X;
    var tooltipYLocation = absoluteTargetLocationY + tooltipYOffset + exports.TOOLTIP_MARGIN_Y;
    if (relativeTargetLocationX +
        tooltipWidth +
        exports.TOOLTIP_MARGIN_X +
        tooltipXOffset >=
        windowWidth) {
        tooltipXLocation =
            absoluteTargetLocationX -
                exports.TOOLTIP_MARGIN_X -
                flipWidth -
                tooltipWidth +
                tooltipXOffset;
    }
    if (relativeTargetLocationY +
        tooltipHeight +
        exports.TOOLTIP_MARGIN_Y +
        tooltipYOffset >=
        windowHeight) {
        tooltipYLocation =
            absoluteTargetLocationY -
                exports.TOOLTIP_MARGIN_Y -
                tooltipHeight +
                tooltipYOffset;
        tooltipYLocation = tooltipYLocation < -50 ? -50 : tooltipYLocation;
    }
    return {
        tooltipXLocation: tooltipXLocation,
        tooltipYLocation: tooltipYLocation,
    };
};
exports.moveTooltip = function (_a) {
    var chartContainerType = _a.chartContainerType, chartOverlay = _a.chartOverlay, tooltip = _a.tooltip, absoluteTargetLocationX = _a.absoluteTargetLocationX, absoluteTargetLocationY = _a.absoluteTargetLocationY, tooltipXOffset = _a.tooltipXOffset, tooltipYOffset = _a.tooltipYOffset, _b = _a.flipWidth, flipWidth = _b === void 0 ? 0 : _b;
    var chartBounds = (chartOverlay === null || chartOverlay === void 0 ? void 0 : chartOverlay.getBoundingClientRect()) || { x: 0, y: 0 };
    var tooltipBounds = (tooltip === null || tooltip === void 0 ? void 0 : tooltip.getBoundingClientRect()) || {
        height: 0,
        width: 0,
    };
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var tooltipHeight = tooltipBounds.height;
    var tooltipWidth = tooltipBounds.width;
    var tooltipXLocation;
    var tooltipYLocation;
    var relativeTargetLocationX = absoluteTargetLocationX + chartBounds.x;
    var relativeTargetLocationY = absoluteTargetLocationY + chartBounds.y;
    if (chartContainerType === 'ABSOLUTE') {
        var absoluteLocation = exports.getAbsoluteTooltipLocation({
            absoluteTargetLocationX: absoluteTargetLocationX,
            absoluteTargetLocationY: absoluteTargetLocationY,
            tooltipXOffset: tooltipXOffset,
            tooltipYOffset: tooltipYOffset,
            windowWidth: windowWidth,
            windowHeight: windowHeight,
            relativeTargetLocationX: relativeTargetLocationX,
            relativeTargetLocationY: relativeTargetLocationY,
            tooltipHeight: tooltipHeight,
            tooltipWidth: tooltipWidth,
            flipWidth: flipWidth,
        });
        tooltipXLocation = absoluteLocation.tooltipXLocation;
        tooltipYLocation = absoluteLocation.tooltipYLocation;
    }
    else {
        var relativeLocation = exports.getRelativeTooltipLocation({
            relativeTargetLocationX: relativeTargetLocationX,
            relativeTargetLocationY: relativeTargetLocationY,
            tooltipWidth: tooltipWidth,
            tooltipHeight: tooltipHeight,
            windowWidth: windowWidth,
            windowHeight: windowHeight,
            flipWidth: flipWidth,
        });
        tooltipXLocation = relativeLocation.tooltipXLocation;
        tooltipYLocation = relativeLocation.tooltipYLocation;
    }
    d3.select(tooltip)
        .style('left', tooltipXLocation + "px")
        .style('top', tooltipYLocation + "px")
        .style('visibility', 'visible')
        .style('opacity', 1);
};
exports.moveTooltipXAxisMarker = function (_a) {
    var tooltipXAxisMarker = _a.tooltipXAxisMarker, tooltipXAxisMarkerText = _a.tooltipXAxisMarkerText, xScale = _a.xScale, xVal = _a.xVal, markerText = _a.markerText, _b = _a.xLocationOffset, xLocationOffset = _b === void 0 ? 0 : _b;
    if (xScale(xVal) !== undefined) {
        var xLocation = xScale(xVal) + xLocationOffset;
        var markerTextLocation = xScale(xVal) + xLocationOffset;
        var markerLocation = xLocation -
            (markerText.length * exports.PIXELS_PER_X_AXIS_LABEL_CHAR +
                exports.X_AXIS_MARKER_PADDING) /
                2;
        if (markerLocation < 0) {
            markerLocation = 0;
            markerTextLocation =
                (markerText.length * exports.PIXELS_PER_X_AXIS_LABEL_CHAR +
                    exports.X_AXIS_MARKER_PADDING) /
                    2;
        }
        d3.select(tooltipXAxisMarker)
            .attr('x', markerLocation)
            .attr('opacity', 1)
            .attr('width', markerText.length * exports.PIXELS_PER_X_AXIS_LABEL_CHAR + exports.X_AXIS_MARKER_PADDING);
        d3.select(tooltipXAxisMarkerText)
            .attr('x', markerTextLocation)
            .text(markerText)
            .attr('opacity', 1);
    }
    else {
        d3.select(tooltipXAxisMarker).attr('opacity', 0);
        d3.select(tooltipXAxisMarkerText).attr('opacity', 0);
    }
};
exports.getMouseXYVal = function (_a) {
    var _b, _c;
    var chartOverlay = _a.chartOverlay, pageX = _a.pageX, pageY = _a.pageY, xScale = _a.xScale, yScale = _a.yScale;
    var boundingRec = chartOverlay === null || chartOverlay === void 0 ? void 0 : chartOverlay.getBoundingClientRect();
    var absoluteMouseXLocation = pageX - ((_b = boundingRec === null || boundingRec === void 0 ? void 0 : boundingRec.x) !== null && _b !== void 0 ? _b : 0);
    var absoluteMouseYLocation = pageY - ((_c = boundingRec === null || boundingRec === void 0 ? void 0 : boundingRec.y) !== null && _c !== void 0 ? _c : 0);
    return {
        mouseXVal: xScale.invert(absoluteMouseXLocation),
        mouseYVal: yScale.invert(absoluteMouseYLocation),
    };
};
exports.hideTooltipComponents = function (_a) {
    var tooltipLine = _a.tooltipLine, tooltip = _a.tooltip, tooltipXAxisMarker = _a.tooltipXAxisMarker, tooltipXAxisMarkerText = _a.tooltipXAxisMarkerText, useTransition = _a.useTransition;
    if (useTransition) {
        d3.select(tooltip).style('visibility', 'hidden').style('opacity', 0);
        if (tooltipLine)
            d3.select(tooltipLine).transition().attr('opacity', 0);
        if (tooltipXAxisMarker)
            d3.select(tooltipXAxisMarker).transition().attr('opacity', 0);
        if (tooltipXAxisMarkerText)
            d3.select(tooltipXAxisMarkerText).transition().attr('opacity', 0);
    }
    else {
        d3.select(tooltip).style('visibility', 'hidden').style('opacity', 0);
        if (tooltipLine)
            d3.select(tooltipLine).attr('opacity', 0);
        if (tooltipXAxisMarker)
            d3.select(tooltipXAxisMarker).attr('opacity', 0);
        if (tooltipXAxisMarkerText)
            d3.select(tooltipXAxisMarkerText).attr('opacity', 0);
    }
};
exports.showTooltipComponents = function (_a) {
    var tooltipLine = _a.tooltipLine, tooltip = _a.tooltip, tooltipXAxisMarker = _a.tooltipXAxisMarker, tooltipXAxisMarkerText = _a.tooltipXAxisMarkerText;
    d3.select(tooltip).style('visibility', 'visible').style('opacity', 1);
    if (tooltipLine)
        d3.select(tooltipLine).transition().attr('opacity', 1);
    if (tooltipXAxisMarker)
        d3.select(tooltipXAxisMarker).transition().attr('opacity', 1);
    if (tooltipXAxisMarkerText)
        d3.select(tooltipXAxisMarkerText).transition().attr('opacity', 1);
};
exports.getTooltipXVal = function (data, xVal, xScale) {
    var uniqueXValues = pipe_1.default(flatMap_1.default(get_1.default('values')), sortBy_1.default(get_1.default('x')), map_1.default(get_1.default('x')), sortedUniq_1.default)(data);
    var bisect = d3.bisector(function (b) { return b; }).left;
    var bisectIndex = bisect(uniqueXValues, xVal);
    var thisClosestXLeft = uniqueXValues[bisectIndex - 1];
    var thisClosestXRight = uniqueXValues[bisectIndex];
    var closestX = Math.abs(xScale(thisClosestXLeft) - xScale(xVal)) <
        Math.abs(xScale(thisClosestXRight) - xScale(xVal))
        ? thisClosestXLeft
        : thisClosestXRight;
    return closestX;
};
exports.getTooltipValueColor = function (colorCodeValues, value) {
    if (!colorCodeValues)
        return 'white';
    return value < 0 ? exports.NEGATIVE_COLOR : exports.POSITIVE_COLOR;
};
